import React from 'react';
import { ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface DrawerItemTextProps {
  primary?: string;
  expanded: boolean;
  children?: React.ReactNode;
}

export const DrawerItemText: React.FC<DrawerItemTextProps> = ({ 
  primary, 
  expanded, 
  children 
}) => {
  const theme = useTheme();
  return (
    <ListItemText
      primary={primary}
      slotProps={{ primary: { noWrap: true, sx: { fontSize: '1rem' } } }}
      sx={{
        opacity: expanded ? 1 : 0,
        transition: theme.transitions.create('opacity', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      }}
    >
      {children}
    </ListItemText>
  );
};